/* eslint-disable react-hooks/exhaustive-deps */
import {
  Download,
  ChevronDown,
  ChevronUp,
  History,
  SquarePen,
  FileText
} from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'

import Breadcrumb from '../../../components/Label/Breadcrumb'
import Notification from '../../../components/Notifications/Notification'
import { BadgeStatusCOA } from '../../../components/atoms/StatusLabel'
import ModalPrDetailTimeline from '../../../components/modal/ReceiveAtWarehouse/PrDetailTimeline'
import ModalUpdateCoa from '../../../components/modal/ReceiveAtWarehouse/UpdateCoa'
import api from '../../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime
} from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import Loading from '../../../components/atoms/Loading'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledDetailField = ({ label, value, col = 3, children }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {children ? children : value}
      </div>
    </Form.Group>
  )
}

function Detail() {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      color: !state.data.hasSlot ? '#C12727' : 'black',
      backgroundColor: 'transparent',
      fontWeight: !state.data.is_reject ? 'normal' : 'bold'
    })
  }

  const { id } = useParams()
  const { state } = useLocation()
  const [isLoading, setIsLoading] = useState(true)
  const [loadingArea, setLoadingArea] = useState(false)
  const [successNotification, setSuccessNotification] = useState(false)
  const [detail, setDetail] = useState({})
  const [areaData, setAreaData] = useState([])
  const [assignAreas, setAssignAreas] = useState([])
  const [openCoa, setOpenCoa] = useState(true)
  const [showModalTimeline, setShowModalTimeline] = useState(false)
  const [showModalUpdateCoa, setShowModalUpdateCoa] = useState(false)
  const [prTimelineId, setPrTimelineId] = useState(null)
  const [detailCoa, setDetailCoa] = useState(null)
  const [downloadDocumentCoa, setDownloadDocumentCoa] = useState({})
  const [conditionItemInbound, setConditionItemInbound] = useState({
    inputValue: '',
    condition: ''
  })

  useEffect(() => {
    fetchDetail()
  }, [id])

  useEffect(() => {
    if (conditionItemInbound?.condition) {
      loadFocusOptions(
        conditionItemInbound?.inputValue,
        conditionItemInbound?.condition
      )
    }
  }, [conditionItemInbound])

  useEffect(() => {
    const successNotification = setTimeout(() => {
      setSuccessNotification(false)
    }, 10000)
    return () => clearTimeout(successNotification)
  }, [successNotification])

  const loadOptions = async (inputValue, condition) => {
    try {
      setLoadingArea(true)
      const res = await api.get('/master/area/all', {
        params: {
          q: inputValue,
          id: detail?.po_info?.target_warehouse + ' - BAJ',
          condition: condition === 'good' ? '' : condition
        }
      })
      if (res.data.success) {
        const options = res.data.data?.reduce(
          (acc, data) => {
            acc.unshift({
              value: data.id,
              label: `${data.name} ${
                data.has_slot ? '' : `- Slot Unavailable!`
              }`,
              hasSlot: data.has_slot,
              is_reject: false
            })
            return acc
          },
          [{ value: null, label: 'TOLAK', hasSlot: false, is_reject: true }]
        )
        setAreaData(
          condition === 'good' ? options.filter((opt) => opt.value) : options
        )
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingArea(false)
    }
  }

  const loadFocusOptions = (inputValue, condition) => {
    loadOptions(inputValue, condition)
  }

  const checkAssignArea = (inboundId) => {
    const lengthItemAssignAreaByInbound = assignAreas.find((inbound) => {
      return inbound.inboundId === inboundId
    })?.items.length
    const lengthItemInbounds = detail?.inbounds.find((inbound) => {
      return inbound.id === inboundId
    })?.items.length

    return lengthItemInbounds === lengthItemAssignAreaByInbound
  }

  const handleSubmitAndSendErp = (inboundId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            if (!checkAssignArea(inboundId)) {
              Swal.close()
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Destination area is required'
              })
              return
            }
            const res = await api.post(
              `inbound/ml-draft/${detail?.po_info?.ml_id}/assign-area`,
              {
                areas: assignAreas.find(
                  (inbound) => inbound.inboundId === inboundId
                )?.items
              }
            )
            if (res.data.success) {
              Swal.close()
              // load data
              fetchDetail()
              Common.showPopUpSuccessMessage('Success')
            }
          } catch (err) {
            Swal.close()
            const errMsg =
              err?.response?.data?.errors?.message || 'An error occurred'
            const swalWithBootstrapButtonError = Swal.mixin({
              customClass: {
                confirmButton: 'btn btn-primary-orange',
                cancelButton: 'btn btn-transparent',
                actions:
                  'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
              },
              buttonsStyling: false
            })
            swalWithBootstrapButtonError
              .fire({
                html: `<p>Send to ERP <span class='text-danger fw-bold text-uppercase'>failed</span></p><br><p>Reason: ${errMsg}</p>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Resend',
                allowOutsideClick: false,
                showCloseButton: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    if (!checkAssignArea(inboundId)) {
                      Swal.close()
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Destination area is required'
                      })
                      return
                    }
                    const res = await api.post(
                      `inbound/ml-draft/${detail?.po_info?.ml_id}/assign-area`,
                      {
                        areas: assignAreas.find(
                          (inbound) => inbound.inboundId === inboundId
                        )?.items
                      }
                    )
                    if (res.data.success) {
                      Swal.close()
                      // load data
                      fetchDetail()
                      Common.showPopUpSuccessMessage('Success')
                    }
                  } catch (err) {
                    Swal.close()
                    const errMsg =
                      err?.response?.data?.errors?.message ||
                      'An error occurred'
                    Common.showPopUpErrorMessage(errMsg)
                  }
                }
              })
          }
        } else {
          return false
        }
      })
  }

  const fetchDetail = async () => {
    try {
      setIsLoading(true)
      const res = await api.get(`inbound/ml-draft/${id}`)
      const { data } = res
      if (data.success) {
        setDetail(data.data)
        const tempAssignArea = data?.data?.inbounds.reduce((acc, cur) => {
          let obj = {
            inboundId: cur.id,
            items: cur.items
              .filter(
                (itemValue) =>
                  itemValue.condition === 'good' ||
                  itemValue.area === 'Area Gudang Karantina'
              )
              .reduce((accItem, curItem) => {
                let itemObj = {
                  item_staging_area_id: curItem.id,
                  area_id: curItem.area_id,
                  is_reject: [
                    'Area Gudang Utama',
                    'Area Gudang Karantina'
                  ].includes(curItem.area)
                    ? false
                    : true
                }
                accItem.push(itemObj)
                return accItem
              }, [])
          }
          acc.push(obj)
          return acc
        }, [])
        setAssignAreas(tempAssignArea)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSetAssignArea = (inboundId, itemId, area) => {
    const assignArea = assignAreas.find(
      (inboundValue) => inboundValue.inboundId === inboundId
    )
    const checkItemStaging = assignArea?.items?.find(
      (itemValue) => itemValue.item_staging_area_id === itemId
    )
    let filterInbound = null
    if (checkItemStaging) {
      filterInbound = assignArea?.items?.map((itemValue) =>
        itemValue.item_staging_area_id === itemId
          ? { ...itemValue, area_id: area.value, is_reject: area.is_reject }
          : itemValue
      )
    } else {
      filterInbound = [
        ...assignArea?.items,
        {
          item_staging_area_id: itemId,
          area_id: area.value,
          is_reject: area.is_reject
        }
      ]
    }
    setAssignAreas((prevInboundState) =>
      prevInboundState.map((inbound) =>
        inbound.inboundId === inboundId
          ? { ...inbound, items: filterInbound }
          : inbound
      )
    )
  }

  const statusCoaMapping = {
    unchecked: 'unchecked',
    match: 'match',
    not_match: 'not match'
  }

  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    revised: 'waiting rnr',
    done: 'done'
  }

  const handleDownloadDocumentCoa = async (batch_id) => {
    try {
      setDownloadDocumentCoa((prev) => ({
        ...prev,
        [batch_id]: true
      }))
      const res = await api.get(`/master/batch/${batch_id}/download-coa`, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-coa-${batch_id}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setDownloadDocumentCoa((prev) => ({
        ...prev,
        [batch_id]: false
      }))
    }
  }

  const handleDownloadLabel = async (labelId) => {
    try {
      const payload = {
        inbound_staging_id: labelId
      }
      const res = await api.post(`/inbound/ml-draft/${id}/label`, payload, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-label-ml-${labelId}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }
  if (isLoading) {
    return <Loading />
  }

  return (
    <Container className="mb-5">
      <Row>
        <Col md={8} className="mt-3">
          <Breadcrumb
            label={detail?.po_info?.ml}
            link={
              state?.source === 'inbound-history'
                ? '/inbound/history'
                : '/inbound/ml'
            }
            back={
              state?.source === 'inbound-history'
                ? 'INBOUND HISTORY'
                : 'ML DRAFT LIST'
            }
            status={statusTextMapping[detail?.inbounds[0]?.status || 'done']}
            type="BadgeStatusPrLists"
            stateValue={state}
          />
        </Col>
        {successNotification && (
          <Notification
            type="success"
            text="Success!"
            handleClose={() => setSuccessNotification(false)}
          />
        )}
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <Card style={cardStyle}>
            <Row>
              <StyledDetailField
                label="Series"
                value={detail?.po_info?.series_number ?? '-'}
                col={3}
              />
              <StyledDetailField
                label="#ERP DOC NO"
                value={detail?.po_info?.erp_doc_no ?? '-'}
                col={3}
              />
              <StyledDetailField
                label="SOURCE WAREHOUSE"
                value={detail?.po_info?.src_warehouse}
                col={3}
              />
              <StyledDetailField
                label="TARGET WAREHOUSE"
                value={detail?.po_info?.target_warehouse}
                col={3}
              />
              <StyledDetailField
                label="#TR"
                value={detail?.po_info?.tr}
                col={3}
              />
              <StyledDetailField
                label="#MR"
                value={detail?.po_info?.mr}
                col={3}
              />
              <StyledDetailField
                label="DELIVERY TYPE"
                value={
                  detail?.po_info?.delivery_type
                    ? firstLetterUpperCase(detail?.po_info?.delivery_type)
                    : 'Internal'
                }
                col={3}
              />
            </Row>
          </Card>
          <Card style={cardStyle}>
            <Row className="mb-3">
              <Col md={12} className="mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="text-secondary" style={{ margin: 0 }}>
                    ITEM & COA
                  </h5>
                  {openCoa ? (
                    <ChevronUp
                      size={16}
                      onClick={() => setOpenCoa(!openCoa)}
                      style={{ cursor: 'pointer' }}
                      className="ms-3"
                    />
                  ) : (
                    <ChevronDown
                      size={16}
                      onClick={() => setOpenCoa(!openCoa)}
                      style={{ cursor: 'pointer' }}
                      className="ms-3"
                    />
                  )}
                </div>
              </Col>
              <Collapse in={openCoa}>
                <div id="item-coa-lists">
                  <Row>
                    <Col md={12} className="mt-3">
                      <Table
                        hover
                        responsive
                        className="mb-4"
                        size="sm"
                        style={{ fontSize: '12px' }}
                      >
                        <thead className="table-secondary">
                          <tr>
                            <th
                              className="p-2 align-middle"
                              style={tableHeaderStyle}
                            >
                              No
                            </th>
                            <th
                              className="p-2 align-middle"
                              style={{ ...tableHeaderStyle, width: '20%' }}
                            >
                              Item Code - Name
                            </th>
                            <th
                              className="p-2 align-middle"
                              style={tableHeaderStyle}
                            >
                              Status COA
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              Batch
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              Total Pack
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              Total Qty
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              COA Document
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              COA MD
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              COA ED
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              Label MD
                            </th>
                            <th
                              className="p-2 text-end align-middle"
                              style={tableHeaderStyle}
                            >
                              Label ED
                            </th>

                            <th
                              className="p-2 text-center align-middle"
                              style={tableHeaderStyle}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {detail?.items_coa?.length > 0 &&
                            detail?.items_coa?.map((item, index) => (
                              <tr key={item?.id}>
                                <td className="p-2">{index + 1}</td>
                                <td className="p-2">
                                  {item?.item?.item_code} -{' '}
                                  {item?.item?.item_name}
                                </td>
                                <td className="p-2">
                                  <BadgeStatusCOA
                                    text={
                                      statusCoaMapping[item?.coa_status] ||
                                      'unchecked'
                                    }
                                  />
                                </td>
                                <td className="p-2">{item?.batch?.batch}</td>
                                <td className="p-2 text-end">
                                  {item?.total_pack}
                                </td>
                                <td className="p-2 text-end">
                                  {item?.total_qty}
                                </td>
                                <td className="p-2 text-end">
                                  <span className="text-primary">
                                    <button
                                      disabled={
                                        downloadDocumentCoa?.[item?.batch_id]
                                      }
                                      onClick={(e) => {
                                        e.preventDefault()
                                        handleDownloadDocumentCoa(
                                          item?.batch_id
                                        )
                                      }}
                                      className={`border-0 bg-transparent ${
                                        downloadDocumentCoa?.[item?.batch_id]
                                          ? 'text-black cursor-not-allowed'
                                          : 'text-primary'
                                      } text-decoration-underline`}
                                    >
                                      {downloadDocumentCoa?.[item?.batch_id]
                                        ? 'Downloading...'
                                        : 'Download'}
                                    </button>
                                  </span>
                                </td>
                                <td className="p-2 text-end">
                                  {item?.coa_pd
                                    ? convertDateWithoutTime(item?.coa_pd)
                                    : '-'}
                                </td>
                                <td className="p-2 text-end">
                                  {item?.coa_ed
                                    ? convertDateWithoutTime(item?.coa_ed)
                                    : '-'}
                                </td>
                                <td className="p-2 text-end">
                                  {item?.label_pd
                                    ? convertDateWithoutTime(item?.label_pd)
                                    : '-'}
                                </td>
                                <td className="p-2 text-end">
                                  {item?.label_ed
                                    ? convertDateWithoutTime(item?.label_ed)
                                    : '-'}
                                </td>

                                <td className="p-2">
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setShowModalUpdateCoa(true)
                                      setDetailCoa(item)
                                    }}
                                  >
                                    <SquarePen size={14} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </div>
              </Collapse>
            </Row>
          </Card>
        </Col>
      </Row>
      <div style={{ margin: 0, padding: 0 }}>
        <div style={{ borderTop: '3px solid #F1F2F7' }} className="mt-4"></div>
      </div>
      <div className="mt-4">
        {detail?.inbounds?.length > 0 &&
          detail?.inbounds.map((inbound) => (
            <Card style={cardStyle} key={inbound.id}>
              <Row>
                <Col xs={6} md={6} lg={6}>
                  <div className="d-flex flex-row justify-content-start gap-2">
                    <History
                      size={16}
                      style={{
                        color: '#828282',
                        marginTop: '.1rem'
                      }}
                      className="cursor-pointer"
                      role="button"
                      onClick={() => {
                        setShowModalTimeline(true)
                        setPrTimelineId(inbound?.id)
                      }}
                    />
                    <p className="text-uppercase fw-bold text-muted">
                      {inbound?.stagings
                        ?.map((staging) => staging?.name)
                        .join(', ')}
                    </p>
                  </div>
                </Col>
                <Col xs={6} md={6} lg={6}>
                  <div
                    className="d-flex flex-column justify-content-center"
                    style={{ marginTop: '.1rem' }}
                  >
                    <div className="d-flex w-100 flex-row justify-content-end fs-6">
                      <div className="d-flex flex-row gap-2">
                        <p className="fw-bold">
                          <span>
                            {statusTextMapping[inbound?.status].toUpperCase()}
                          </span>
                        </p>
                        <FileText size={16} color="#828282" />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  <Table
                    hover
                    responsive
                    className="shadow-sm mb-4 bg-white rounded"
                    size="sm"
                    style={{ fontSize: '12px' }}
                  >
                    <thead className="table-secondary">
                      <tr>
                        <th className="p-2 align-middle">Palet</th>
                        <th
                          className="p-2 align-middle"
                          style={{ width: '20%' }}
                        >
                          Item Code - Name
                        </th>
                        <th className="p-2 text-end">Batch</th>
                        <th className="p-2 text-end">Pack</th>
                        <th className="p-2 text-end">Condition</th>
                        <th className="p-2 text-end">Location</th>
                        <th className="p-2 text-end">Destination Area</th>
                        <th className="p-2 align-middle">Label</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!inbound?.items?.length && (
                        <tr>
                          <td colSpan={7} className="fw-bold text-center">
                            Data empty
                          </td>
                        </tr>
                      )}
                      {inbound?.items?.length > 0 &&
                        inbound?.items?.map((item) => (
                          <tr>
                            <td
                              className="p-2"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {!item.palet_id ? '-' : `#${item.palet_id}`}
                            </td>
                            <td
                              className="p-2"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {item.item_code} - {item.item_name}
                            </td>
                            <td
                              className="p-2 text-end"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {item.batch}
                            </td>
                            <td
                              className="p-2 text-end"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {item.total_pack}
                            </td>
                            <td
                              className="p-2 text-end"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              <Badge
                                bg={`${
                                  item.condition === 'good'
                                    ? 'success'
                                    : 'danger'
                                }`}
                                className="text-uppercase fw-bold p-2"
                              >
                                {`${
                                  item.condition === 'good' ? 'baik' : 'rusak'
                                }`}
                              </Badge>
                            </td>
                            <td
                              className="p-2 text-end"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {item.current_location}
                            </td>
                            <td
                              className="p-2 text-end"
                              style={{
                                backgroundColor: `${
                                  item.from_mobile ? '#FFCCCC' : 'white'
                                }`
                              }}
                            >
                              {(!inbound?.erp_code ||
                                (inbound?.has_karantina &&
                                  !inbound?.erp_code_karantina)) &&
                                inbound?.status === 'waiting_om' && (
                                  <Select
                                    menuPortalTarget={document.body}
                                    isSearchable={true}
                                    isLoading={loadingArea}
                                    loadingMessage={() => 'Loading...'}
                                    options={areaData}
                                    defaultOptions
                                    placeholder="Select Assign Area"
                                    styles={customStyles}
                                    key={1}
                                    autoLoad={false}
                                    onFocus={() =>
                                      setConditionItemInbound(
                                        (prevConditionItemInbound) => ({
                                          ...prevConditionItemInbound,
                                          condition: item?.condition
                                        })
                                      )
                                    }
                                    onInputChange={(e) => {
                                      setConditionItemInbound({
                                        inputValue: e,
                                        condition: item?.condition
                                      })
                                    }}
                                    onChange={(e) =>
                                      handleSetAssignArea(
                                        inbound?.id,
                                        item?.id,
                                        e
                                      )
                                    }
                                  />
                                )}
                              {(inbound?.erp_code ||
                                (inbound?.has_karantina &&
                                  inbound?.erp_code_karantina)) && (
                                <p className="text-end d-flex h-100 justify-content-end">
                                  {item?.area && <span>{item?.area}</span>}
                                  {!item?.area && (
                                    <span
                                      className="text-danger text-uppercase"
                                      style={{
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      tolak
                                    </span>
                                  )}
                                </p>
                              )}
                            </td>
                            <td className="p-2 align-middle">
                              <Button
                                variant={`${
                                  ['put_away', 'done'].includes(inbound?.status)
                                    ? 'warning'
                                    : 'secondary'
                                }`}
                                className={`${
                                  !['put_away', 'done'].includes(
                                    inbound?.status
                                  )
                                    ? 'disabled opacity-25'
                                    : ''
                                }`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleDownloadLabel(item?.id)}
                                disabled={
                                  !['put_away', 'done'].includes(
                                    inbound?.status
                                  )
                                }
                              >
                                <Download size={14} />
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </Col>
                {inbound?.status === 'waiting_om' &&
                  (!inbound?.erp_code ||
                    (inbound?.has_karantina &&
                      !inbound?.erp_code_karantina)) && (
                    <Row>
                      {inbound?.erp?.erp_status === false &&
                        inbound?.erp?.err_notes && (
                          <Col md={7}>
                            <Row>
                              <Col md={12}>
                                <p>
                                  {' '}
                                  {inbound?.erp?.description}, <br />
                                  status:{' '}
                                  <span
                                    style={{
                                      color:
                                        inbound?.erp?.erp_status === true
                                          ? 'green'
                                          : '#C12727'
                                    }}
                                    className="ms-2 fw-bold text-uppercase"
                                  >
                                    {inbound?.erp?.erp_status === true
                                      ? 'Success'
                                      : 'Failed'}
                                  </span>
                                </p>
                              </Col>
                              <Col md={12}>
                                <span>Failed Reason: </span>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: inbound?.erp?.err_notes
                                  }}
                                ></div>
                              </Col>
                            </Row>
                          </Col>
                        )}
                      <Col
                        md={
                          inbound?.erp?.erp_status === false &&
                          inbound?.erp?.err_notes
                            ? 5
                            : 12
                        }
                        className="d-flex flex-row justify-content-end mb-3"
                      >
                        <small className="text-danger me-4 mt-1 fs-6">
                          Ensure that all destination areas match the items
                        </small>

                        <div>
                          <Button
                            className="btn btn-warning text-white"
                            onClick={() => handleSubmitAndSendErp(inbound?.id)}
                            style={{ fontSize: '11.8px' }}
                          >
                            Submit & Send to ERP
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
              </Row>
            </Card>
          ))}
      </div>
      <div style={{ margin: 0, padding: 0 }}>
        <div style={{ borderTop: '3px solid #F1F2F7' }} className="mt-4"></div>
      </div>
      <Card style={cardStyle} className="mt-4">
        <Row>
          <Col md={12} className="mb-3">
            <h5 className="fw-bold"> ITEM RECEIPT DETAILS</h5>
          </Col>
          <Col md={12}>
            <Table
              hover
              responsive
              className="shadow-sm mb-4 bg-white rounded"
              size="sm"
              style={{ fontSize: '12px' }}
            >
              <thead className="table-secondary">
                <tr>
                  <th className="p-2 align-middle" style={{ width: '20%' }}>
                    Item
                  </th>
                  <th className="p-2 text-end">Batch</th>
                  <th className="p-2 text-end">TR Pack</th>
                  <th className="p-2 text-end">TR Qty</th>
                  <th className="p-2 text-center">Accepted Pack</th>
                  <th className="p-2 text-end">Accepted Qty</th>
                  <th className="p-2 text-end">Quarantine Pack</th>
                  <th className="p-2 text-end">Quarantine Qty</th>
                  <th className="p-2 text-end">Rejected Pack</th>
                  <th className="p-2 text-end">Rejected Qty</th>
                </tr>
              </thead>
              <tbody>
                {!detail?.receipt_detail?.length && (
                  <tr>
                    <td colSpan={10} className="fw-bold text-center">
                      <p>No data</p>
                    </td>
                  </tr>
                )}
                {detail?.receipt_detail?.length > 0 &&
                  detail?.receipt_detail?.map((receipt_detail) => (
                    <tr>
                      <td className="p-2">
                        {receipt_detail?.item_code} - {receipt_detail?.item}
                      </td>
                      <td className="p-2">{receipt_detail?.batch}</td>
                      <td className="p-2 text-end">
                        {receipt_detail?.acc_pack}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.acc_qty}
                      </td>
                      <td className="p-2 text-center">
                        {receipt_detail?.acc_pack}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.acc_qty}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.quarantine_pack}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.quarantine_qty}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.damaged_qty}
                      </td>
                      <td className="p-2 text-end">
                        {receipt_detail?.damaged_pack}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
      <Card style={cardStyle} className="mt-4">
        <Row>
          <StyledDetailField
            label="CREATED BY"
            value={detail?.po_info?.createdby ?? '-'}
            col={3}
          />
          <StyledDetailField
            label="CREATED AT"
            value={convertDateWithTime(detail?.po_info?.createdAt)}
            col={3}
          />
          <StyledDetailField
            label="LAST UPDATED BY"
            value={detail?.po_info?.updatedby}
            col={3}
          />
          <StyledDetailField
            label="LAST UPDATED AT"
            value={convertDateWithTime(detail?.po_info?.updatedAt)}
            col={3}
          />
        </Row>
      </Card>

      <ModalPrDetailTimeline
        show={showModalTimeline}
        timelineId={prTimelineId}
        onHide={() => setShowModalTimeline(false)}
      />

      <ModalUpdateCoa
        show={showModalUpdateCoa}
        onHide={() => setShowModalUpdateCoa(false)}
        detailCoa={detailCoa}
        refreshdata={() => fetchDetail()}
      />
    </Container>
  )
}

export default Detail
